
import React from 'react';
import ReactDOM from 'react-dom/client'; 
import store from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import './index.css'
import App from "./App";
import { Provider } from "react-redux";
import { AuthProvider } from './contexts/AuthContext';
import { TaskProvider } from './contexts/TaskContext';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}> {/* <-- Redux Provider MUST be outermost here */}
      <AuthProvider>       {/* <-- AuthProvider (uses Redux) inside Redux Provider */}
        <TaskProvider>     {/* <-- TaskProvider (uses Redux) inside AuthProvider */}
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </TaskProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>

);